"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundManager = void 0;
const types_1 = require("../types");
const implementations_1 = require("./implementations");
class RoundManager {
    constructor(config) {
        this._infinite = implementations_1.InfiniteRound.for(config);
        this._timed = implementations_1.TimedRound.for(config);
        this._all = new Map([
            [this._infinite.type, this._infinite],
            [this._timed.type, this._timed],
        ]);
    }
    /**
     * Returns a `Round` instance for the provided chain ID
     * @param config The chain config
     */
    static for(config) {
        return new RoundManager(config);
    }
    /**
     * Get the round state
     * @param type The round type
     * @param params The params required to get the round state
     */
    static getState(type, params) {
        return this.get(type).getState(params); // TODO: Fix type issue.
    }
    /**
     * Infinite round utilities
     */
    get infinite() {
        return this._infinite;
    }
    /**
     * Timed round utilities
     */
    get timed() {
        return this._timed;
    }
    /**
     * Get a round utility class
     * @param type The round type
     */
    static get(type) {
        if (!this._all.has(type)) {
            throw new Error(`Unknown round type: ${type}`);
        }
        return this._all.get(type);
    }
    /**
     * Get a round utility class instance
     * @param type The round type
     */
    get(type) {
        if (!this._all.has(type)) {
            throw new Error(`Unknown round type: ${type}`);
        }
        return this._all.get(type);
    }
    /**
     * @notice Get a round contract instance
     * @param type The round type
     * @param address The round address
     */
    getContract(type, address) {
        return this.get(type).getContract(address);
    }
    /**
     * @notice Returns the implementation contract address for the provided round type
     * @param type The round type
     */
    getImpl(type) {
        return this.get(type).impl;
    }
    /**
     * Get the round state
     * @param type The round type
     * @param params The params required to get the round state
     */
    getState(type, params) {
        return RoundManager.getState(type, params);
    }
    /**
     * Convert the provided round configuration to a config struct
     * @param round The round information
     */
    async getConfigStruct(round) {
        return this.get(round.roundType).getConfigStruct(round.config);
    }
    /**
     * Estimate the round registration message fee cost (in wei)
     * @param type The round type
     * @param configStruct The round configuration struct
     */
    async estimateMessageFee(type, configStruct) {
        return this.get(type).estimateMessageFee(configStruct);
    }
    /**
     * ABI-encode the provided round configuration struct
     * @param type The round type
     * @param configStruct The round configuration struct
     */
    encode(type, configStruct) {
        return this.get(type).encode(configStruct);
    }
}
exports.RoundManager = RoundManager;
RoundManager._all = new Map([
    [types_1.RoundType.INFINITE, implementations_1.InfiniteRound],
    [types_1.RoundType.TIMED, implementations_1.TimedRound],
]);
